export const TASK_MANAGER_ASSESSMENTS_GRAPH_SETTINGS_ROUTE = 'settings-tpm-assessments-graph'

export const DESCRIPTION_MAX_LENGTH = 300
export const OPERATION_MAX_LENGTH = 600
export const IDENTIFICATION_MAX_LENGTH = 8

export const CONFORMITIES_CONFIG_KEY = 'task_manager_conformities'
export const NONCOMFORMITIES_CONFIG_KEY = 'task_manager_non_conformities'
export const GROUP_THRESHOLDS_CONFIG_KEY = 'task_manager_groups'
export const GROUPED_TASKS_BY_TEMPORALITY_CONFIG_KEY = 'grouped_tasks_by_temporality'

export const TASK_MANAGER = 'task-manager'
export const INTERVENTION_MODES = 'intervention-modes'
export const TECHNICAL_MODULES = 'technical-modules'
export const SUPER_CATEGORIES = 'super-categories'

export const ACHIEVE_RULES = {
  "RANGE": 0,
  "GREATER_THAN": 1,
  "LESS_THAN": 2,
}
export const MIN_VALUE_TARGET_ACHIEVE_RULE = -999999
export const MAX_VALUE_TARGET_ACHIEVE_RULE = 999999

export const MIN_VALUE_PERCENTAGE_TARGET_ACHIEVE_RULE = 0
export const MAX_VALUE_PERCENTAGE_TARGET_ACHIEVE_RULE = 100

export const ASSESSMENT_TYPE = {
  "OK_NOK": 0,
  "VALUE": 1,
  "OK_NOK_NA": 2,
  "VALUE_NA": 3,
  "NUMERIC_SCALE": 4,
  "FREE_TEXT": 5,
  "PERCENTAGE": 6,
}

export const ASSESSMENT_TYPE_WITHOUT_NA = {
  "OK_NOK": 0,
  "VALUE": 1,
  "NUMERIC_SCALE": 4,
  "FREE_TEXT": 5,
  "PERCENTAGE": 6,
}

export const ASSESSMENT_TYPE_WITH_NA = {
  "OK_NOK_NA": 2,
  "VALUE_NA": 3,
}

export const ASSESSMENT_VALUES = {
  "NOK": 0,
  "OK": 1,
  "NOT_APPLICABLE": -2,
  "NON_ASSESSED": -1,
}

export const FREQUENCIES = {
  'DAILY_FREQUENCY': 0,
  'WEEKLY_FREQUENCY': 1,
  'MONTHLY_FREQUENCY': 2,
  'ON_DEMAND_FREQUENCY': 3,
  'HOURLY_FREQUENCY': 4,
  'MONTHLY_BY_WEEK_FREQUENCY': 5,
  'NO_FREQUENCY': 6,
  'ANNUAL_FREQUENCY': 7,
}

export const ORDER_FREQUENCIES = {
  'task_manager.messages.daily_frequency': 0,
  'common.messages.weekly': 1,
  'task_manager.messages.monthly_by_date_frequency': 2,
  'task_manager.messages.monthly_by_week_frequency': 3,
  'common.messages.annual': 4,
  'task_manager.messages.on_request_frequency': 5,
}

export const WEEKS_MONTH = [
  { value: 1, text: 'task_manager.messages.first' },
  { value: 2, text: 'task_manager.messages.second' },
  { value: 3, text: 'task_manager.messages.third' },
  { value: 4, text: 'task_manager.messages.fourth' },
]

export const DAYS_OF_WEEK = 6
export const SUNDAY=0

const MINIMUM_COMMON_DAYS_IN_MONTHS = 28
export const MONTHLY_FREQUENCY = Array(MINIMUM_COMMON_DAYS_IN_MONTHS).fill().map((_, i) => {
  return {
    value: i + 1,
    text: String(i + 1),
  }
})

export const HOURS_IN_DAY = 24
export const HOURS_PER_DAY = Array(HOURS_IN_DAY).fill().map((_, i) => {
  if (i < 10) return '0' + i
  return i.toString()
})

export const MINUTES = ["00", "15", "30", "45"]

export const ALL_ASSESSORS_ID = 0

export const filterFields = {
  assessmentResult: 'assessment_result',
  assessors: 'assessors',
  assessorPeople: 'assessor_persons',
  categories: 'categories',
  checkpoints: 'checkpoints',
  enabled: 'enabled',
  endDate: 'created_lte',
  frequencies: 'frequencies',
  perimeters: 'perimeters',
  products: 'products',
  qFactor: 'q_factor',
  shifts: 'shifts',
  shiftTimeFrame: 'shift_time_frame',
  startDate: 'created_gte',
  byCurrentShift: 'by_current_shift',
  withoutActions: 'without_actions',
  withoutImprovementIdeas: 'without_improvement_ideas',
  launchedByPeople: 'launched_by',
  groupTypes: 'group_type',
  groupNames: 'groups',
  sPoint: 's_point',
  nonConformitiesRequireAction: 'non_conformities_require_action',
  interventionModes: 'intervention_mode',
  superCategories: 'super_categories',
  templates: 'template',
  carryOver: 'carry_over',
}

export const KEYPOINT_HALF_HEIGHT = 0.9
const X_OFFSET_PERCENTAGE = 1.25
const Y_OFFSET_PERCENTAGE = 1.5

const getPositionOffset = function (point) {
  const leftWithOffset = point.x - (X_OFFSET_PERCENTAGE / 100)
  const topWithOffset = point.y - (Y_OFFSET_PERCENTAGE / 100)

  return {x:leftWithOffset, y:topWithOffset}
}

export const getPointPosition = function (point, useOffset=true) {
  let pointPosition = point
  if (useOffset) pointPosition = getPositionOffset(point)
  const left = `calc(${(pointPosition.x * 100)}%)`
  const top = `calc(${(pointPosition.y * 100)}%)`
  return {left: `${left}`, top: `${top}`}
}

const okBallData = {
  dataTestModifier: 'compliances',
  color: 'info-green',
  assessmentResult: ASSESSMENT_VALUES.OK,
}
const nokBallData = {
  dataTestModifier: 'nonCompliances',
  color: 'info-red',
  assessmentResult: ASSESSMENT_VALUES.NOK,
}
const notApplicableBallData = {
  dataTestModifier: 'notApplicable',
  color: 'info-grey',
  assessmentResult: ASSESSMENT_VALUES.NOT_APPLICABLE,
}
const nonAssessedBallData = {
  dataTestModifier: 'nonAssessed',
  color: 'info-light-grey',
  assessmentResult: ASSESSMENT_VALUES.NON_ASSESSED,
}
const previousNoCompliance = {
  dataTestModifier: 'previousNoCompliance',
  color: 'info-orange',
  assessmentResult: ASSESSMENT_VALUES.NOK,
}
export const BALLS_CONFIGURATION = {
  ok: okBallData,
  nok: nokBallData,
  na: notApplicableBallData,
  not_assessed: nonAssessedBallData,
  previous_no_compliance:previousNoCompliance,
}

export const ON_DEMAND_GROUP_TYPE = 0
export const STANDARD_GROUP_TYPE = 1
export const GROUP_TYPES = {
  [ON_DEMAND_GROUP_TYPE]: 'task_manager.messages.on_request_frequency',
  [STANDARD_GROUP_TYPE]: 'task_manager.messages.standard_group_type',
}

export const COMPLETED_TASKS_TABLE_NAME = 'COMPLETED_TASK_LIST'
export const COMPLETED_TASKS_GROUPS_TABLE_NAME = 'COMPLETED_TASK_GROUPS_LIST'

export const PLANNED = 0
export const PLANNED_DONE = 1
export const PLANNED_EXPIRED = 2
export const EXPIRED_WITH_REPLANNED = 3
export const REPLANNED = 4
export const REPLANNED_DONE = 5
export const REPLANNED_EXPIRED = 6
export const DONE_WITHOUT_PLANNING = 7

export const TASKS_GROUPS_PLAN_TYPES = {
  [PLANNED]: { class: 'planned', text: 'task_manager.messages.group_planned'},
  [PLANNED_DONE]: { class: 'done-planned', text: 'task_manager.messages.group_planned_done'},
  [PLANNED_EXPIRED]: { class: 'planned-expired', text: 'task_manager.messages.group_planned_expired'},
  [DONE_WITHOUT_PLANNING]: { class: 'done-not-planned', text: 'task_manager.messages.group_done_not_planified'},
  [EXPIRED_WITH_REPLANNED]: { class: 'expired-with-replanned', text: 'task_manager.messages.group_expired_with_replanned'},
  [REPLANNED]: {class: 'replanned', text: 'task_manager.messages.group_replanned'},
  [REPLANNED_DONE]: {class: 'done-replanned', text: 'task_manager.messages.group_replanned_done'},
  [REPLANNED_EXPIRED]: { class: 'replanned-expired', text: 'task_manager.messages.group_replanned_expired'},
}
